import { render, staticRenderFns } from "./SalesProcess.vue?vue&type=template&id=631087d6&scoped=true&"
import script from "./SalesProcess.vue?vue&type=script&lang=js&"
export * from "./SalesProcess.vue?vue&type=script&lang=js&"
import style0 from "./SalesProcess.vue?vue&type=style&index=0&id=631087d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631087d6",
  null
  
)

export default component.exports